"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracing = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Tracing';
class Tracing extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.Tracing`, {}) {
}
exports.Tracing = Tracing;
//# sourceMappingURL=tracing.js.map